/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx, css, } from '@emotion/core';
import styled from '@emotion/styled';
import { LayoutContext, ColContext, } from './grid-context';
import Grid from './grid';
import Spacing from './spacing';

const gridColumns = (props:any,) => css`
  @supports (display: grid) {
    grid-template-columns: repeat(${props.layout === 1 ? '12' : '8'}, 1fr);
  }
`;

const StyledRow = styled.div`
  ${Grid.grid} ${Grid.close}
  & {
    flex-wrap: wrap;
  }

  & > div {
    @media only screen and (-ms-high-contrast: none) {
      margin-right: '0';
    }

    &:last-child {
      margin-right: 0;
      margin-bottom: 0;
    }
  }

  ${(props:any,) => props.column === 1 ? gridColumns(props) : null}

  @media only screen and (-ms-high-contrast: none) {
    margin-bottom: ${Spacing.Close};
  }
`;

const Row = (props:any,) => (
  <LayoutContext.Consumer>
    {layout => (
      <ColContext.Consumer>
        {(column) => {
          return <StyledRow layout={layout} column={column} {...props} />;
        }}
      </ColContext.Consumer>
    )}
  </LayoutContext.Consumer>
);

Row.displayName = 'Row';

Row.propTypes = {
  children: PropTypes.node,
};

export default Row;
